export const Lang = {
  title: 'Welcome to St. Andrews Links',
  cards: [
    {
      title: 'Map(s)',
    },
    {
      title: 'Information',
    },
    {
      title: 'Terms & Conditions',
    },
    {
      title: 'Bookings',
    },
  ],
};
